import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment-timezone';

@Component({
  selector: 'app-all-people',
  templateUrl: './all-people.component.pug',
  styleUrls: ['./all-people.component.scss'],
  standalone: false
})
export class AllPeopleComponent implements OnChanges {
  @Input() people: any[] = [];
  @Input() selectedPeople: any[] = [];
  @Input() employeesTab = false;
  @Input() selectMode = false;
  @Input() selectAllTotal = false;
  @Output() viewProfile: EventEmitter<any> = new EventEmitter();
  @Output() selectProfile: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router,
  ) { }

  ngOnChanges(): void {
    this.format_dates();
  }
  onViewProfile(person) {
    if (!this.selectMode) {
      this.viewProfile.emit(person.uid);
    } else {
      this.selectPerson(person);
    }
  }

  format_dates() {
    this.people.forEach(person => {
      if (person['last_activity_date']) {
        person['last_activity_formatted'] = moment(person['last_activity_date']).format('ll');
      }
      if (person['created']) {
        person['created_formatted'] = moment(person['last_activity_date']).format('ll');
      }
      if (person['employment_start_date']) {
        person['employment_start_date'] = moment(person['employment_start_date']).format('ll');
      }
    })
  }

  avatarInitials(person: { first_name?: string | null; last_name?: string | null } | null): string {
    const first = (person?.first_name || '').charAt(0);
    const last = (person?.last_name || '').charAt(0);
    return `${first}${last}`;
  }

  selectPerson(person) {
    if (person['selected']) {
      person['selected'] = false;
      let index = this.selectedPeople.findIndex(s => s.uid === person.uid);
      if (index > -1) {
        this.selectedPeople.splice(index, 1);
      }
    } else {
      person['selected'] = true;
      this.selectedPeople.push(person);
    }
    this.selectProfile.emit(person.uid);
  }
}
